import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue';
import DxDataGrid, { DxColumn, DxExport, DxButton } from 'devextreme-vue/data-grid';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';

interface Filter { category: number | null; start: string; end: string; }
interface OrderData { [key:string]:any; }


export default /*@__PURE__*/_defineComponent({
  __name: 'GridComenzi',
  props: {
    filters: {}
  },
  emits: ["openOrder"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const comenziData = ref<OrderData[]>([]);

watch(() => props.filters, async (filters) => {
  const queryParams: string[] = [];
  if(filters.category!==null) queryParams.push(`Tipcomanda=${filters.category}`);
  if(filters.start) queryParams.push(`DataStart=${filters.start}`);
  if(filters.end) queryParams.push(`DataEnd=${filters.end}`);

  const url = AppSetting.API_Url_ComercialOdata + 'PRO_Comenzi' + (queryParams.length ? `?${queryParams.join('&')}` : '');

  const store = new ODataStore({
    url,
    key:'Id',
    version:4,
    beforeSend:(e:any)=>{
      e.headers = {
        "Content-Type":"application/json",
        "Authorization":"Bearer "+localStorage.getItem("ERA_Jwt")
      };
    },
  });

  comenziData.value = await store.load();
}, { immediate:true });

function onOpenOrder(e: any){
  emit('openOrder', e.row.data);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "data-source": comenziData.value,
    "key-expr": "Id",
    "show-borders": "",
    "column-auto-width": false,
    "column-resizing-mode": 'nextColumn',
    "allow-column-reordering": true,
    "filter-row": { visible: true },
    "search-panel": { visible: true, placeholder: 'Cauta...' },
    "column-chooser": { enabled: true, mode: 'select', allowSearch: true },
    paging: { pageSize: 15 },
    height: "100%"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxExport), {
        enabled: true,
        formats: ['pdf','xlsx'],
        "allow-export-selected-data": true
      }),
      _createVNode(_unref(DxColumn), { caption: "Date Comandă" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "Cod",
            caption: "Cod"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Nume",
            caption: "Client"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataComenzii",
            caption: "Data Comenzii",
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Tipcomanda",
            caption: "Tip Comandă"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ValoareComanda",
            caption: "Valoare",
            "data-type": "number",
            format: "#0.00"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TotalComanda",
            caption: "Total",
            "data-type": "number",
            format: "#0.00"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Motive",
            caption: "Motive"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Stare",
            caption: "Stare"
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxColumn), { caption: "Audit / Utilizatori" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "UserCreare",
            caption: "User Creare"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataCreare",
            caption: "Data Creare",
            "data-type": "date",
            format: "yyyy-MM-dd"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "UserModificare",
            caption: "User Modificare"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataModificare",
            caption: "Data Modificare",
            "data-type": "date",
            format: "yyyy-MM-dd"
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxColumn), { caption: "Contract / Documente" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "NumeContract",
            caption: "Nume Contract"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "NumarContract",
            caption: "Numar Contract"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PathContract",
            caption: "Path Contract"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Observatii",
            caption: "Observatii"
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxColumn), { caption: "Expediere / Facturare" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "AgentId",
            caption: "AgentID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "FacturatorId",
            caption: "FacturatorID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ExpeditieTipId",
            caption: "Expeditie Tip"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Tva",
            caption: "TVA",
            "data-type": "number",
            format: "#0.00"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Discount",
            caption: "Discount",
            "data-type": "number",
            format: "#0.00"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Facturat",
            caption: "Facturat"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "FacturareZiDinLuna",
            caption: "Zi Facturare"
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxColumn), { caption: "Proiect / Valuta" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "ProiectId",
            caption: "ProiectID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ValutaId",
            caption: "ValutaID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "ComandaSursaId",
            caption: "Comanda Sursa ID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Curs",
            caption: "Curs"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretValutaId",
            caption: "Pret Valuta ID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PretCurs",
            caption: "Pret Curs"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PreturiCalculate",
            caption: "Preturi Calculate"
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxColumn), { caption: "Altele" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "PeStoc",
            caption: "Pe Stoc"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "BonDeConfirmare",
            caption: "Bon Confirmare"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DelegatId",
            caption: "DelegatID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "PunctId",
            caption: "PunctID"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "DataStartProductie",
            caption: "Data Start Productie",
            "data-type": "date"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "TimpExecutie",
            caption: "Timp Executie"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Prioritate",
            caption: "Prioritate"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "Explicatie",
            caption: "Explicatie"
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        width: "150"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), { onClick: onOpenOrder }, {
            content: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("span", { style: {"color":"white","font-weight":"bold"} }, "Deschide Comanda", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-source"]))
}
}

})